module.exports = __webpack_public_path__ + "img/play.89471e71.svg";